import { useEffect } from "react";
import { thisBaseURL} from "../../utils/helper.js";

function loadScriptError(onError) {
  console.log(`Failed ${onError.target.src} didn't load correctly`);
}

export default function TableauReports() {
   useEffect(() => {
    const LoadTableauScript = () => {
      const externalScript = document.createElement("script");
      externalScript.onerror = loadScriptError;
      externalScript.id = "external";
      externalScript.async = true;
      externalScript.type = "text/javascript";
      externalScript.setAttribute("crossorigin", "anonymous");
      document.body.appendChild(externalScript);
      externalScript.src = window.location.origin + thisBaseURL + '/js/tableauReport.js';
    };
    LoadTableauScript();
  }, []);
  return (
	<div className="container">
	    <div className="row">
	      <div className="col-md-12 col-sx-12 col-sm-12">
	        <div class='tableauPlaceholder' id='viz1675143338131' style={{position: 'relative', overflow: 'visible', height:'100%', width:'100%'}}><noscript>
	        <a href='#'>
	        <img alt='Dashboard ' 
	        src='https:&#47;&#47;public.tableau.com&#47;static&#47;images&#47;In&#47;IncidentsDatabaseJan&#47;Dashboard&#47;1_rss.png' style={{border: 'none'}}/>
	        </a>
	        </noscript>
	        <object class='tableauViz'  style={{display: 'none'}}><param name='host_url' value='https:&#47;&#47;public.tableau.com&#47;' /> 
	        <param name='embed_code_version' value='3' /> <param name='site_root' value='' /><param name='name' value='IncidentsDatabaseJan&#47;Dashboard' />
	        <param name='tabs' value='no' /><param name='toolbar' value='yes' />
	        <param name='static_image' value='https:&#47;&#47;public.tableau.com&#47;static&#47;images&#47;In&#47;IncidentsDatabaseJan&#47;Dashboard&#47;1.png' /> 
	        <param name='animate_transition' value='yes' /><param name='display_static_image' value='yes' />
	        <param name='display_spinner' value='yes' /><param name='display_overlay' value='yes' /><param name='display_count' value='yes' />
	        <param name='language' value='en-US' /></object></div> 
	        <div style={{position: 'relative', top: '-25px', zIndex: '999', opacity: '1', background: 'rgb(235 243 235 / 10%)', height: '50px', width: '110%', content:'', overflow: 'hidden', backgroundColor: 'white'}}></div>
	      </div>
	    </div>
    </div>
  );
}
